import "./index.css";

export function App() {
  return (
    <main>
      <h1>Albi's projects:</h1>
      <ul>
        <li>
          Oct 2025: <a href="where-are-we-going">where are we going</a>
        </li>
        <li>
          Jul 2025:{" "}
          <a
            href="https://opensea.io/collection/happy-birthday-etherium"
            target="_blank"
            rel="noopener"
          >
            Happy Birthday Etherium
          </a>
        </li>
        <li>
          2021-2025:{" "}
          <a href="https://verselets.garden" target="_blank" rel="noopener">
            verselets
          </a>
        </li>
      </ul>
    </main>
  );
}

export default App;
